<template>
  <div class="change-password">
    <div class="breadcrumb-area pos-relative mb-3">
      <h1>Cập nhật Merchant</h1>
    </div>
    <div class="mx-3 card" style="max-width: 500px">
      <div class="card-body px-20">
        <Form ref="formref" :form="form" @submit="onSubmit" />
      </div>
    </div>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true">
    </VueLoadingOverlay>
  </div>
</template>

<script>
import { MerchantService } from '@/services/merchant.service'
import Form from './_form.vue'
export default {
  data () {
    return {
      showLoading: false,
      form: {}
    }
  },
  components: { Form },
  async created () {
    this.get()
  },
  methods: {
    async get () {
      this.showLoading = true
      try {
        const res = await MerchantService.get(this.$route.params.id)
        if (res.success) {
          this.form = res.data
          this.$refs.formref.setExpectedDeliveryDate(this.form.expectedDeliveryTime)
          this.$refs.formref.onChangeProvince(res.data.cityCode)
        } else this.showFailMx(res.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    },
    async onSubmit (params) {
      try {
        this.showLoading = true
        const data = await MerchantService.update(params)
        if (data.success) {
          this.showSuccessMx('Cập nhật merchant thành công').then((s) =>
            this.$router.push('/merchant/detail/' + this.$route.params.id)
          )
        } else this.showFailMx(data.message)
      } catch (error) {
        this.showFailMx(error.message ?? error)
      } finally {
        this.showLoading = false
      }
    }
  }
}
</script>
